export default "__VITE_ASSET__CVz18G3e__"